<template>
  <div class="support-page">
    <div class="title">
      <atomic-icon id="back" @click="backToPreviousPage" />
      <h3 class="heading">
        {{ content?.currentLocaleData?.title || content?.defaultLocaleData?.title }}
      </h3>
    </div>

    <div id="chatra-wrapper" />
  </div>
</template>

<script setup lang="ts">
  import type { ISupportPage } from '~/types';

  const globalStore = useGlobalStore();
  const profileStore = useProfileStore();
  const { profile } = storeToRefs(profileStore);
  const { currentLocale } = storeToRefs(globalStore);
  const { changeMobileMenu } = useIsMobileMenuOpen();

  const contentParams = {
    contentKey: 'supportPageContent',
    contentRoute: ['pages', 'support'],
    isPage: true,
  };

  const { getContentData } = useContentLogic<ISupportPage>(contentParams);
  const { data: content } = await useLazyAsyncData(getContentData);

  const chatLocale = computed(() => {
    const chatLocales = ['en', 'de', 'fr', 'es', 'nl', 'pt', 'it', 'ru'];
    return chatLocales.includes(currentLocale.value?.code || '') ? currentLocale.value?.code : 'en';
  });

  const chatraConfig = {
    startHidden: false,
    mode: 'frame',
    language: chatLocale.value,
    injectTo: 'chatra-wrapper',
    clientId: profile?.value?.uniqNumber || '',
  };

  onMounted(() => {
    window.ChatraSetup = chatraConfig;
    window.Chatra('restart');
  });

  const backToPreviousPage = () => {
    const router = useRouter();
    changeMobileMenu(true);
    router.back();
  };
</script>

<style src="~/assets/styles/pages/support.scss" lang="scss" />
